<div class="tw-w-full">
  <basic-input
    class="tw-w-full"
    [control]="titleControl()"
    label="Title"
    [placeholder]="titlePlaceholder()"
    [id]="titleInputId()"
    [required]="true"
    [allowClearButton]="false"
  />
</div>

<div class="tw-w-full">
  <app-date-range-picker
    [startDate]="startDate()"
    [endDate]="endDate()"
    [showIndefiniteOption]="false"
    [compactCalendarOnMobile]="true"
    [minSelectableDate]="eventPublicStartDate()"
    [initialVisibleMonthDate]="eventPublicStartDate()"
    [disabledDateRanges]="disabledDateRanges()"
    [silentDisabledDateRanges]="silentDisabledDateRanges()"
    [allowedWeekDays]="allowedWeekDays()"
    [useBasicInputTrigger]="true"
    [basicInputLabel]="'Date'"
    [basicInputPlaceholder]="'Date'"
    [basicInputId]="dateInputId()"
    [basicInputRequired]="true"
    [displayControlOverride]="dateDisplayControl()"
    (rangeSelected)="rangeSelected.emit($event)"
  />
</div>

<div class="tw-flex tw-flex-col tw-gap-1">
  <div class="tw-flex tw-gap-6">
    <label class="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-800 tw-font-inter">
      <input
        type="radio"
        [attr.name]="hoursRadioName()"
        class="tw-h-4 tw-w-4 tw-border-gray-300 tw-text-blue-600 focus:tw-ring-blue-500"
        [checked]="hoursMode() === TimingExceptionHoursMode.CLOSED"
        (change)="hoursModeChange.emit(TimingExceptionHoursMode.CLOSED)"
      />
      Closed
    </label>
    <label class="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-800 tw-font-inter">
      <input
        type="radio"
        [attr.name]="hoursRadioName()"
        class="tw-h-4 tw-w-4 tw-border-gray-300 tw-text-blue-600 focus:tw-ring-blue-500"
        [checked]="hoursMode() === TimingExceptionHoursMode.DIFFERENTHOURS"
        (change)="hoursModeChange.emit(TimingExceptionHoursMode.DIFFERENTHOURS)"
      />
      Different hours
    </label>
  </div>
</div>

@if (hoursMode() === TimingExceptionHoursMode.DIFFERENTHOURS) {
  <div class="tw-flex tw-gap-4 tw-flex-wrap tw-mt-8">
    <div class="timing-exception-form__time-field tw-flex-1 tw-flex tw-flex-col tw-gap-1">
      <app-event-time-picker
        label="Opening time"
        [hour]="startHour()"
        [minute]="startMinute()"
        [invalid]="!!timeRangeError()"
        (hourChange)="startHourChange.emit($event)"
        (minuteChange)="startMinuteChange.emit($event)"
      />
      @if (timeRangeError(); as oerr) {
        <div class="tw-text-red-600 dark:tw-text-red-500 tw-font-inter tw-text-xs" role="alert">{{ oerr }}</div>
      }
    </div>
    <div class="timing-exception-form__time-field tw-flex-1 tw-flex tw-flex-col tw-gap-1">
      <app-event-time-picker
        label="Closing time"
        [hour]="endHour()"
        [minute]="endMinute()"
        [invalid]="!!timeRangeError()"
        (hourChange)="endHourChange.emit($event)"
        (minuteChange)="endMinuteChange.emit($event)"
      />
      @if (timeRangeError(); as cerr) {
        <div class="tw-text-red-600 dark:tw-text-red-500 tw-font-inter tw-text-xs" role="alert">{{ cerr }}</div>
      }
    </div>
  </div>
}

